import * as S from './styles'
import { usePartnership } from './usePartnership'
import { PartnersContainer } from '../partners'
import { TextWithHighlighted } from '@/components'
import { Button } from '@/components/button'

export type PartnerShipProps = {
  handleScrollToElement: () => void
}
export const Partnership: React.FC<PartnerShipProps> = ({
  handleScrollToElement,
}) => {
  const { fontSizes, partnershipData } = usePartnership()

  return (
    <S.PartnershipContainer>
      <TextWithHighlighted
        size={fontSizes.title}
        align="center"
        text={partnershipData.title}
      />
      <TextWithHighlighted
        size={fontSizes.subtitle}
        align="center"
        text={partnershipData.subtitle}
      />

      <PartnersContainer partnerData={partnershipData.partnerData} />
      <Button onClick={handleScrollToElement}>
        {partnershipData.buttonText}
      </Button>
    </S.PartnershipContainer>
  )
}
